/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * The source repository a registry entry links for its server. A registry declaration: nothing verifies the endpoint runs this code.
 */
export type ExternalMCPRepository = {
  /**
   * Hosting service the repository lives on, such as github
   */
  source?: string | undefined;
  /**
   * Path within the repository holding the server, for monorepos
   */
  subfolder?: string | undefined;
  /**
   * Repository URL
   */
  url: string;
};

/** @internal */
export const ExternalMCPRepository$inboundSchema: z.ZodMiniType<
  ExternalMCPRepository,
  unknown
> = z.object({
  source: z.optional(z.string()),
  subfolder: z.optional(z.string()),
  url: z.string(),
});

export function externalMCPRepositoryFromJSON(
  jsonString: string,
): SafeParseResult<ExternalMCPRepository, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ExternalMCPRepository$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ExternalMCPRepository' from JSON`,
  );
}
